import React from "react"
import BaseHero from "@lekoarts/gatsby-theme-cara/src/components/hero"

export default function Hero(props) {

  return (
      <BaseHero {...props} />
  )
}